import { CrudService } from 'ui-shared';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ProdutoUnidadeNegocioEntity } from '@catalogo/models/produto-unidade-negocio.entity';
import { OPERACAO_API_URL } from "@catalogo/features/compartilhado/const/constantes";

@Injectable({ providedIn: 'root' })
export class ProdutoUnidadeNegocioDataService extends CrudService<ProdutoUnidadeNegocioEntity> {

    protected url: string;
    urlOriginal: string;

    constructor(
        @Inject(OPERACAO_API_URL) urlBase: string,
        @Inject(HttpClient) protected httpClient: HttpClient
    ) {
        super(urlBase, httpClient);
        this.urlOriginal = `${urlBase}/v1/Produto/<id>/UnidadeNegocio`;
    }

    public withParentId(parentId: string) {
        this.url = this.urlOriginal.replace("<id>", parentId);
        return this;
    }
}
